import React from 'react'

const Alert = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/alert',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g
      fill='none'
      fillRule='evenodd'
      stroke={primaryColor}
      strokeWidth='1.2'
    >
      <path d='M12.395 15.57v1.086a2.082 2.082 0 0 1-2.076 2.076 2.082 2.082 0 0 1-2.076-2.076V15.57' />
      <path
        d='M4.42 11.513H3.83C2.823 11.513 2 12.447 2 13.59s.823 2.076 1.829 2.076H16.81c1.006 0 1.829-.934 1.829-2.076s-.823-2.076-1.829-2.076h-.591V7.696c0-3.698-2.642-6.696-5.9-6.696C7.061 1 4.42 3.998 4.42 7.696v3.817z'
        strokeLinejoin='round'
      />
    </g>
  </svg>
)

export default Alert
